export const EMBEDDED_CONFLUENCE_NAVIGATION_MESSAGE = 'EMBEDDED_CONFLUENCE_NAVIGATION';
